import { CatchballLoopDiagram as CatchballLoopDiagramCore } from '@diagram-kit/CatchballLoopDiagram';
import { useDiagramTheme } from './useDiagramTheme';

export function CatchballLoopDiagram() {
  const p = useDiagramTheme();
  return <CatchballLoopDiagramCore palette={p} />;
}
